import { createFileRoute, redirect } from '@tanstack/react-router';

// Analytics moved out from under Settings to its own top-level route at
// /$organizationName/analytics. This redirect preserves bookmarks and the
// in-app link target prior to the move.
export const Route = createFileRoute('/$organizationName/settings/analytics')({
  component: () => null,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/$organizationName/analytics',
      params,
      search: search as any,
    });
  },
});
